var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10654 2.44L6.19988 0.533336C2.99988 2.97334 0.89321 6.73334 0.706543 11H3.37321C3.57321 7.46667 5.38654 4.37334 8.10654 2.44ZM24.6265 11H27.2932C27.0932 6.73334 24.9865 2.97334 21.7999 0.533336L19.9065 2.44C22.5999 4.37334 24.4265 7.46667 24.6265 11ZM21.9999 11.6667C21.9999 7.57334 19.8132 4.14667 15.9999 3.24V2.33334C15.9999 1.22667 15.1065 0.333336 13.9999 0.333336C12.8932 0.333336 11.9999 1.22667 11.9999 2.33334V3.24C8.17321 4.14667 5.99988 7.56 5.99988 11.6667V18.3333L3.33321 21V22.3333H24.6665V21L21.9999 18.3333V11.6667ZM13.9999 26.3333C14.1865 26.3333 14.3599 26.32 14.5332 26.28C15.3999 26.0933 16.1065 25.5067 16.4532 24.7067C16.5865 24.3867 16.6532 24.04 16.6532 23.6667H11.3199C11.3332 25.1333 12.5199 26.3333 13.9999 26.3333Z",
    fill: "#1F2320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.47aa522c12e17c5fcf325472aa484a41.svg";
export { ForwardRef as ReactComponent };